export const saintnicolasTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_sectors: 'Secteurs',
  breadcrumb_current: 'Saint-Nicolas',
  hero_h1: "Couvreur à Saint-Nicolas : toiture haut de gamme et réfection",
  hero_subtitle: "Spécialistes des toitures résidentielles à Saint-Nicolas. Bardeau premium, tôle moderne, garantie 10 ans signée.",
  hero_cta: "Demander ma soumission Saint-Nicolas",
  hero_stat_1: 'Plusieurs dizaines de mises en relation à Saint-Nicolas',
  hero_stat_2: 'Certifié',
  hero_stat_3: 'Spécialistes tôle',

  // Connaitre le quartier
  quartier_h2: "Saint-Nicolas : un secteur résidentiel exigeant",
  quartier_p1: "Saint-Nicolas, c'est un des secteurs les plus dynamiques de Lévis, avec une forte concentration de maisons construites entre 2000 et 2020. Les développements comme les Rivières, Mont-Marie et Bernières comptent majoritairement des cottages 2 étages et bungalows haut de gamme avec toitures architecturales de qualité supérieure. La proximité de la route 132 et de l'autoroute Jean-Lesage attire une clientèle exigeante qui privilégie la durabilité et l'esthétique.",
  quartier_p2: "On y voit aussi de plus en plus de conversions vers la tôle joint debout, signe d'une préoccupation long terme et valeur de revente. Nos couvreurs partenaires connaissent chaque développement et adaptent les matériaux aux exigences de chaque quartier.",

  // Profil toitures
  profil_h2: "Ce qu'on voit le plus à Saint-Nicolas",
  profil_1_title: 'BARDEAU ARCHITECTURAL HAUT DE GAMME',
  profil_1_desc: "Maisons 2000-2010 arrivant à mi-vie de leur toiture originale. Première réfection exige même qualité ou supérieure. On utilise BP Mystique, IKO Cambridge ou GAF Timberline HDZ.",
  profil_2_title: 'CONVERSIONS VERS LA TÔLE',
  profil_2_desc: "Tendance forte : passage du bardeau à la tôle joint debout pour durée 50 ans et valeur revente accrue. 30 % de nos installations à Saint-Nicolas en 2025.",
  profil_3_title: 'TOITURES COMPLEXES',
  profil_3_desc: "Cottages contemporains avec lucarnes multiples, vallées et toits cathédraux. Exigent un savoir-faire technique pointu et une estimation précise des détails.",

  // Services
  services_h2: "Tous nos services de toiture à Saint-Nicolas",
  service_1: 'Réfection bardeau architectural premium',
  service_2: 'Installation tôle joint debout',
  service_3: 'Toit plat moderne (annexes contemporaines)',
  service_4: 'Ferblanterie sur mesure',
  service_5: 'Inspection préachat / prévente',
  service_6: 'Déneigement hiver',

  // Prix
  prix_h2: "Prix moyens d'une toiture à Saint-Nicolas 2026",
  prix_table_type: 'Type de maison',
  prix_table_price: 'Fourchette bardeau premium 2026',
  prix_row_1_type: 'Bungalow 1 400-1 700 pi²',
  prix_row_1_price: '9 000 $ – 13 500 $',
  prix_row_2_type: 'Cottage 1 900-2 300 pi²',
  prix_row_2_price: '12 000 $ – 17 500 $',
  prix_row_3_type: 'Cottage premium 2 500+ pi²',
  prix_row_3_price: '16 000 $ – 24 000 $',
  prix_row_4_type: 'Conversion en tôle joint debout',
  prix_row_4_price: '22 000 $ – 45 000 $',
  prix_note: "Tarifs typiques observés à Saint-Nicolas. Soumission précise après inspection sur place.",

  // Projets récents
  projets_h2: "Quelques projets récents à Saint-Nicolas",
  projet_1_title: 'Développement les Rivières',
  projet_1_desc: "Réfection bardeau premium IKO Cambridge, septembre 2025, cottage 2 200 pi²",
  projet_2_title: 'Secteur Bernières',
  projet_2_desc: "Conversion bardeau vers tôle joint debout ardoise, mai 2025, cottage 2 étages",
  projet_3_title: 'Mont-Marie',
  projet_3_desc: "Toiture neuve bardeau architectural double épaisseur, juillet 2025",

  // Témoignage
  temoignage_quote: "Notre maison dans les Rivières date de 2008. Le bardeau architectural d'origine avait encore 5-6 ans à vivre, mais on voulait passer à quelque chose de plus durable pour la revente future. Marc-Antoine nous a présenté plusieurs options tôle et on a opté pour le joint debout en ardoise. Le résultat est spectaculaire — la maison a l'air neuve. L'équipe a travaillé 4 jours, toujours propres, toujours respectueux. Les voisins ont tous fait des commentaires positifs. Investissement qui paie.",
  temoignage_author: 'Jean-François P.',
  temoignage_rue: 'Secteur les Rivières',
  temoignage_city: 'Saint-Nicolas',
  temoignage_detail: "Toiture tôle joint debout, mai 2025",

  // Zones proches
  zones_h2: 'On dessert aussi les secteurs voisins',
  zone_saint_romuald: 'Saint-Romuald',
  zone_charny: 'Charny',
  zone_st_jean: 'Saint-Jean-Chrysostome',
  zone_pintendre: 'Pintendre',

  // CTA Final
  cta_h2: "Votre toiture à Saint-Nicolas mérite un vrai spécialiste",
  cta_subtitle: 'Soumission gratuite en 2h, équipe certifiée, garantie 10 ans signée.',
  cta_button: "Demander ma soumission",
  cta_phone: '418-476-9950',

  // Shared
  phone_number: '418-476-9950',
};

export default saintnicolasTranslations;